import React, { useEffect, useState } from 'react'

// includes
import EditMode from './includes/EditMode'

// react toastify
import { toast } from 'react-toastify';

// messages
import {
    ADD_DOMAIN_FIRST
} from 'utlis/AppMessages/AppMessages'

export default function SendersInfo(props) {
    // props
    const {
        notificationsData,
        setNotificationsData,
    } = props

    // states
    const [editModeVisibility, setEditModeVisibility] = useState(false)

    // const [senderInfo, setSenderInfo] = useState({ // EXAMPLE
    //     senderEmail: "",
    //     senderName: "",
    //     repliesEmail: "",
    // })
    const [senderInfo, setSenderInfo] = useState(null)

    useEffect(() => {
        if (notificationsData) {
            setSenderInfo({ // setting sender info
                senderEmail: notificationsData?.postmark_from_address,
                senderName: notificationsData?.postmark_from_name,
                repliesEmail: notificationsData?.postmark_from_address,
            })
        }
    }, [notificationsData])

    // on edit button clicked
    const handleEditClick = ev => {
        ev.preventDefault()

        if ((!notificationsData?.postmark_domain) || notificationsData?.postmark_domain === null) { // if domain name is not added yet
            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(ADD_DOMAIN_FIRST, {
                autoClose: 2000,
                onClose: () => {
                    // scrolling window to top
                    window.scrollTo(0, 0)
                }
            })
        } else {
            setEditModeVisibility(true) // enabling edit mode
        }
    }

    return (
        <React.Fragment>
            {
                /* header */
                editModeVisibility ? (
                    <React.Fragment>
                        <EditMode
                            notificationsData={notificationsData}
                            setNotificationsData={setNotificationsData}

                            setEditModeVisibility={setEditModeVisibility}

                            senderInfo={senderInfo}
                        />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {/* page border box 2 */}
                        <div className={`page-border-box2 mb-3 mb-md-4 edit-senders-info ${((!notificationsData?.postmark_domain) || notificationsData?.postmark_domain === null) ? "not-available" : ""}`}>
                            <div className="pbb2-inner d-flex">
                                <div className="text-sec media-body pe-3">
                                    <div className="app-header-wrapper heading-sm mb-2">
                                        <p className="app-heading text-capitalize mb-2">Sender’s name and email address</p>
                                        <p className="app-desc st-fs-14">
                                            You can set the email address that you want to send your notifications from. The address has to be on a custom domain, as email services do not allow using their addresses to send emails by third-party services. Also, you can specify the name that appears next to the email address and helps customers identify you. It can be your company name or any other name of your liking.
                                        </p>
                                    </div>

                                    <p className="senders-info-box mb-3">
                                        <span className="desc me-1">Customer notifications are sent from</span>
                                        <span className="from-name st-fw-600 me-1">{senderInfo?.senderName ?? ""}</span>
                                        <span className="from-email st-fw-600">{`<${senderInfo?.senderEmail ?? ""}>`}</span>
                                    </p>

                                    <p className="add-info text-black-50">
                                        Replies to your emails are delivered to {senderInfo?.repliesEmail ?? ""}
                                    </p>

                                </div>

                                <div className="btn-sec">
                                    <button className="st-btn st-btn-sm" onClick={handleEditClick}>
                                        Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}
